import Api from './rest/CrmStageApi';

export default new Api();
